import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

/** CLOUDWEB-18349: Фича включения оплаты через мидас в TariffBuy на вебе */
export const dmrMidasBuyWeb: boolean = isFeature('dmr-midas-buy');
/** CLOUDWEB-18349: Фича включения оплаты через мидас в TariffBuy на таче */
export const dmrMidasBuyTouch: boolean = isFeature('dmr-midas-buy-touch');
export const dmrMidasBuyEnabled: boolean = IS_MOBILE_BROWSER ? dmrMidasBuyTouch : dmrMidasBuyWeb;

/** CLOUDWEB-19295: Фича включения оплаты через мидас в TariffBuy для триалов на таче */
export const dmrMidasTrialTouch = isFeature('dmr-midas-trial-touch');

/** CLOUDWEB-19295: Фича включения оплаты через мидас в окне оплаты с сайдбаром(VkBuyModalWithSidebar) */
export const dmrMidasFastcheckout = isFeature('dmr-midas-fastcheckout');

export const dmrMidasRenew: boolean = isFeature('dmr-midas-renew');

export const dmrMidasWelcomeTrial: boolean = isFeature('dmr-midas-welcome-trial');
export const dmrMidasSpacePromo: boolean = isFeature('dmr-midas-space-promo');

if (dmrMidasBuyEnabled) {
    registerExperiment('midas-buy', dmrMidasBuyEnabled, [
        AnalyticEventNames.TARIFF_CLICK,
        AnalyticEventNames.FAST_CHECKOUT_SHOWN,
        AnalyticEventNames.TARIFF_BUY,
    ]);
}
